<template>
  <div>
    <px-view-header title="Cadastro de produto"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <v-container v-if="loadingProduto">
      <px-circular-loading/>
    </v-container>
    <v-container v-if="!loadingProduto">
      <v-card class="rounded-card elevation-0">
        <v-tabs v-model="tab">
          <v-tab>Produto</v-tab>
          <v-tab>Fornecedores</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card class="rounded-card elevation-0" flat>
              <v-card-text>
                <px-cadastro-produto-tab
                  ref="cadastroDadosBasicos"
                  :produto="produto"
                  :loading-produto="loadingProduto"
                  :cadastros-adicionais="cadastrosAdicionais"
                  :erp-campos-integracao="erpCamposIntegracao"/>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="rounded-card elevation-0" flat>
              <v-card-text>
                <px-cadastro-fornecedor-tab
                  :produto="produto"
                  :loading-produto="loadingProduto"/>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <div>
          <v-btn color="primary"
                 class="normal-btn-text rounded-tag-small elevation-0"
                 :loading="loadingProduto"
                 :disabled="produto.$$hasFileLoading"
                 @click="onClickSave">
            Salvar
          </v-btn>
          <v-btn text
                 class="normal-btn-text elevation-0"
                 @click="onClickBack">
                Cancelar
          </v-btn>
        </div>
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { onlyNumbers } from '@/utils/regex-utils';
import { mapGetters } from 'vuex';
import { getCadastroAdicional } from '@/modules/cadastros-adicionais/cadastros-adicionais-utils';
import { validateCamposErp, initialStateCamposErp } from '@/modules/produtos/campos-erp/validate-campos-erp';
import CadastroProdutoTab from './cadastro/CadastroProdutoDadosBasicosTab.vue';
import CadastroFornecedorTab from './cadastro/CadastroFornecedorTab.vue';
import ProdutoService from '../service/produtos-service';

export default {
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Produtos' },
        { text: 'Meus produtos' },
      ],
      loadingProduto: false,
      isCopy: this.$route.params.isCopy,
      produtoId: this.$route.params.id,
      produto: {
        descricao: null,
        codigo: null,
        arquivos: [],
        unidadeMedida: null,
        ncm: null,
        casasDecimais: null,
        especificacao: null,
        isCotavel: true,
        fornecedores: [],
        cadastrosAdicionais: [],
        grupoProduto: null,
        icms: null,
        ipi: null,
        precoTarget: null,
        observacaoInterna: null,
        observacaoExterna: null,
        codigoFornecedor: null,
        ativo: true,
        tipoProduto: null,
      },
      cadastrosAdicionais: null,
    };
  },
  computed: {
    ...mapGetters('user', ['erpCamposIntegracao']),
    tab: {
      get() {
        return this.$store.getters['cadastroProduto/tab'];
      },
      set(tab) {
        this.$store.dispatch('cadastroProduto/tab', tab);
      },
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.produtos' });
    },
    onClickSave() {
      if (this.$refs.cadastroDadosBasicos.validateForm()) {
        return;
      }
      this.salvar(this.produto);
    },
    setupCadastrosAdicionais() {
      this.cadastrosAdicionais.armazem = getCadastroAdicional(this.produto.cadastrosAdicionais, 'ARMAZEM');
      this.cadastrosAdicionais.contaContabil = getCadastroAdicional(this.produto.cadastrosAdicionais, 'CONTA_CONTABIL');
      this.cadastrosAdicionais.contaFinanceira = getCadastroAdicional(this.produto.cadastrosAdicionais, 'CONTA_FINANCEIRA');
    },
    setupCopiaProduto(dataProduto) {
      const produto = { ...dataProduto };
      produto.id = undefined;
      produto.codigo = undefined;
      produto.codigoFornecedor = undefined;
      if (produto.fornecedores && produto.fornecedores.length) {
        produto.fornecedores = produto.fornecedores
          .map(fornecedorGestao => ({
            ...fornecedorGestao,
            id: undefined,
          }));
      }
      return produto;
    },
    setupProduto(dataProduto) {
      const produto = { ...dataProduto };
      return produto;
    },
    getProduto() {
      this.loadingProduto = true;
      ProdutoService.get(this.produtoId)
        .then((response) => {
          if (this.isCopy) {
            this.produto = this.setupCopiaProduto(response.data);
            this.setupCadastrosAdicionais();
            return;
          }
          this.produto = this.setupProduto(response.data);
          this.setupCadastrosAdicionais();
        })
        .finally(() => {
          this.loadingProduto = false;
        });
    },
    buildCadastrosAdicionaisPayload() {
      if (!this.cadastrosAdicionais) {
        return [];
      }
      return [
        this.cadastrosAdicionais.armazem,
        this.cadastrosAdicionais.contaContabil,
        this.cadastrosAdicionais.contaFinanceira,
      ].map((cadastro) => {
        if (cadastro) {
          return {
            id: cadastro.id,
          };
        }
        return null;
      }).filter(cadastro => cadastro);
    },
    buildPayload(produto) {
      const toSave = { ...produto };
      toSave.ncm = onlyNumbers(toSave.ncm);
      toSave.grupoProduto = toSave.grupoProduto || null;
      toSave.precoTarget = toSave.precoTarget || null;
      toSave.fornecedores = toSave.fornecedores;
      toSave.cadastrosAdicionais = this.buildCadastrosAdicionaisPayload();
      return toSave;
    },
    validateCadastrosAdicionais() {
      const [isValid, message] = validateCamposErp(this.erpCamposIntegracao,
        this.cadastrosAdicionais);
      if (!isValid) {
        this.$toast(message, { color: 'error' });
      }
      return isValid;
    },
    salvar(produto) {
      if (!this.validateCadastrosAdicionais()) {
        return;
      }
      this.loading = true;
      ProdutoService.save(this.buildPayload(produto))
        .then(() => {
          if (this.produtoId && !this.isCopy) {
            this.$toast('Produto atualizado com sucesso', { color: 'success' });
            this.onClickBack();
            return;
          }
          this.$toast('Produto criado com sucesso', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.cadastrosAdicionais = initialStateCamposErp(this.erpCamposIntegracao);
    if (this.produtoId) {
      this.getProduto();
    }
    this.tab = 0;
  },
  components: {
    pxCadastroProdutoTab: CadastroProdutoTab,
    pxCadastroFornecedorTab: CadastroFornecedorTab,
  },
};
</script>
